import { render, staticRenderFns } from "./recommendDialog.vue?vue&type=template&id=5b32e9ae&scoped=true&"
import script from "./recommendDialog.vue?vue&type=script&lang=js&"
export * from "./recommendDialog.vue?vue&type=script&lang=js&"
import style0 from "./recommendDialog.vue?vue&type=style&index=0&id=5b32e9ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32e9ae",
  null
  
)

export default component.exports